// extracted by mini-css-extract-plugin
export default {"container":"style_container__ryia2","headSection":"style_headSection__1cqnr","bodySection":"style_bodySection__my2QO"};